import { useEffect } from "react";

import { BTText } from "@btnet/core-components";

import "./StepUpAuthCallback.less";

/**
 * Message types for step-up authentication window communication
 */
export const STEP_UP_AUTH_MESSAGE_TYPE = "STEP_UP_AUTH_RESULT";

export interface IStepUpAuthMessage {
    type: typeof STEP_UP_AUTH_MESSAGE_TYPE;
    success: boolean;
    error?: string;
}

/**
 * Landing page for step-up authentication callback.
 * This page is opened in a new tab after Auth0 authentication completes.
 * It verifies the authentication status and communicates the result back to the opener window.
 */
export const StepUpAuthCallback: React.FC = () => {
    useEffect(() => {
        const verifyAuthAndNotify = async () => {
            // Check if we have an opener window
            if (!window.opener || window.opener.closed) {
                return;
            }

            // Send success message to opener
            const message: IStepUpAuthMessage = {
                type: STEP_UP_AUTH_MESSAGE_TYPE,
                success: true,
            };
            window.opener.postMessage(message, window.location.origin);
        };

        void verifyAuthAndNotify();
    }, []);

    return (
        <div className="step-up-auth-callback">
            <>
                <BTText text="✓ Authentication successful!" size="distinct-md" />
                <BTText text="This window will close automatically." size="distinct-sm" />
            </>
        </div>
    );
};
